import {
  apiGetAssessmentFile,
  apiGetStudentWorks,
  apiAddWorkToAssessmentFile,
  apiRemoveWorkFromAssessmentFile
} from '../../common/api/assessment'

const fetchAssessmentFileWorks = assessmentFileId => ({
  requestPrefix: 'WORKS_STORE:FETCH',
  params: { assessmentFileId },
  request: () =>
    apiGetAssessmentFile(assessmentFileId, {
      include:
        'assessment_file.details,assessment_file.works,assessment_file.work.names,assessment_file.work.media,assessment_file.work.medium.image,assessment_file.work.timestamps,assessment_file.student_types,assessment_file.student_type.account,assessment_file.student_type.status,assessment_file.work.medium.thumb,assessment_file.policy,assessment_file.student_type.account.names'
    })
})

const selectWork = workId => ({
  type: 'WORKS_STORE:SELECT_WORK_SUCCESS',
  workId
})

const setMedia = page => ({
  type: 'WORKS_STORE:SET_MEDIA_SUCCESS',
  page
})

const openAddWorksDialog = (assessmentFileId, workIds, studentId) => ({
  type: 'WORKS_STORE:ADD_WORKS_DIALOG:OPEN',
  params: {
    assessmentFileId,
    workIds,
    studentId
  }
})

const closeAddWorksDialog = () => ({
  type: 'WORKS_STORE:ADD_WORKS_DIALOG:CLOSE'
})

const fetchStudentWorks = studentId => ({
  requestPrefix: 'WORKS_STORE:FETCH_STUDENT_WORKS',
  params: { studentId },
  request: () =>
    apiGetStudentWorks(studentId, {
      include:
        'account.student_type.works,account.student_type.work.names,account.student_type.work.status,account.student_type.work.timestamps,account.student_type.work.year_group,account.student_type.work.year_group.names,account.student_type.work.year_group.order,account.student_type.works.limit.20,account.student_type.works.order.desc,account.student_type.works.page.1,account.student_type.work.media,account.student_type.work.medium.thumb'
    })
})

const addWorkToAssessmentFile = (workId, assessmentFileId) => ({
  requestPrefix: 'WORKS_STORE:ADD_WORKS',
  params: { workId, assessmentFileId },
  request: () => {
    return apiAddWorkToAssessmentFile(workId, assessmentFileId)
  }
})

const removeWorkFromAssessmentFile = (workId, assessmentFileId) => ({
  requestPrefix: 'WORKS_STORE:REMOVE_WORK',
  params: { workId, assessmentFileId },
  request: () => {
    return apiRemoveWorkFromAssessmentFile(workId, assessmentFileId)
  }
})

export {
  fetchAssessmentFileWorks,
  selectWork,
  setMedia,
  openAddWorksDialog,
  closeAddWorksDialog,
  fetchStudentWorks,
  addWorkToAssessmentFile,
  removeWorkFromAssessmentFile
}
